import React, {Fragment} from "react";
import SweetAlertBase from "./SweetAlertBase";
import Icon from '../Icon';

import "../../../assets/sass/components/modals/sa-popup.scss";

class SA_PopUp extends SweetAlertBase {

    config = {
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
    }

    setHtml = (data) => {
        return (
            <Fragment>
                <div className="sa-popup-content">
                    <Icon svg={data.image}/>
                    <h2>{data.title}</h2>
                    <p>{data.text}</p>
                </div>
            </Fragment>
        )
    }

    type() {
      return 'sm';
    }

    className() {
        return "sa-popup";
    }

    confirmButtonClasses() {
        return "btn btn-primary btn-md btn-block";
    }

    cancelButtonClasses() {
        return "btn btn-secondary btn-md btn-block";
    }
};

export default SA_PopUp;